import { Stack, StackProps, Typography } from '@mui/material';

interface NoResultsProps extends StackProps {
    message?: string;
}
const defaultMessage = 'No results found.';

const styles = {
    fontSize: 20,
    textAlign: 'center',
    color: 'gray',
};

const NoResults = ({ message, ...props }: NoResultsProps) => {
    return (
        <Stack width="100%" height="400px" justifyContent="center" alignItems="center" {...props}>
            <Typography variant="body1" sx={{ ...styles }}>
                {message || defaultMessage}
            </Typography>
        </Stack>
    );
};

export default NoResults;
